import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  AddShip,
  AddStaff,
  CompanyDashboard,
  CompanyDashboardLayout,
  CompanyDeckLogBookList,
  CompanySoundLogBookList,
  CompanySoundLogBookViewList,
  CompanyViewDeckLog,
  EditShip,
  EditStaff,
  EditVoyage,
  GarbageLogBookList,
  DailyShipStaffTask,
  ListenginelogBooks,
  ListOilRecordLog,
  ListOilRecordLogTwo,
  ListShip,
  ListStaff,
  ViewEngineLogBook,
  VoyageListing,
  ViewDailyShipStaffTask,
  AuditTrailstaffcom,
  AuditTrailvoyagecom,
  ViewGarbageLog,
  ViewOilRecordLog,
  ViewOilRecordLogTwo,
  AuditTrailDeckCom,
  AuditTrailEnginelog,
  AuditTrailSounding,
  AuditTrailGarbage,
  AuditTrailOil,
  AuditTrailOilTwo,
  AuditTraildaily,
  CIICalculationList,
  CompanyProfile,
  DailyConsumptionList,
  GarbageLogBookListTwo,
  ViewGarbageLogTwo,
  AuditTrailGarbageTwo,
  ViewBallastRecordBook,
  ListBallastRecordbook,
  AuditTrailBallastRecord,
  AuditTraildailyComsumption,
  AuditTrailBunkerRecord,
  AuditTrailBunkerdelivery,
  AuditTrailFuelChangeover,
  AuditTrailBunker,
  ViewCargoRecordBook,
  ListCargoRecordbook,
  AuditTrailCargo,
  FeatureRequest,
  Feedback,
  AllIssues,
  PhotographicAnalysis,
  PhotographicAnalysisList,
  AddMachinery,
  MachineryRegisterList,
  AddEquipment,
  EquipmentRegisterList,
  FunctionHierarchy,
  JobTasksList,
  JobTaskView,
  RestHoursDashboardCom,
  RestHoursCrewRecordsCom,
  RestHoursLogListCom,
  RestHoursRecordsCom,
  ViolationsCom,
} from "../company";
import LogHours from "../staff/pages/rest-hours/LogHours";
import ListBunkerReportCom from "../company/pages/bunker-report/list";
import ViewBunkerReportCom from "../company/pages/bunker-report/view";
import ListBunkerDetailsCom from "../company/pages/sulphur-record-com/sulphur-bunker-details-com/list";
import EditBunkerDetailsCom from "../company/pages/sulphur-record-com/sulphur-bunker-details-com/edit";
import ListBunkerDeliveryCom from "../company/pages/sulphur-record-com/bunker-delivery-note-com/list";
import ViewBunkerDeliveryCom from "../company/pages/sulphur-record-com/bunker-delivery-note-com/view";
import ListFuelChangeoverCom from "../company/pages/sulphur-record-com/fuel-changeover-com/list";
import ViewBunkerFuelChangeoverCom from "../company/pages/sulphur-record-com/fuel-changeover-com/view";
import ShipComparisonPage from "../staff/pages/ShipComparison/ShipComparisonPage";
import Bugs from "../company/pages/bugs/bugs";
import ChangeRequests from "../company/pages/change-request/ChangeRequest";
// 🔹 ODS RECORDS
import ListCompanyEquipContainingLog from "../company/pages/ods-records/equip-containing-log/list";
import ViewCompanyEquipContainingLog from "../company/pages/ods-records/equip-containing-log/view";
import ListCompanySupplyAndDischargeLog from "../company/pages/ods-records/supply-and-discharge-log/list";
import ViewCompanySupplyAndDischargeLog from "../company/pages/ods-records/supply-and-discharge-log/view";
import ListCompanyRefrigerationEquipLog from "../company/pages/ods-records/refrigeration-equip-log/list";
import ViewCompanyRefrigerationEquipLog from "../company/pages/ods-records/refrigeration-equip-log/view";
import CompanyOfficeStaffList from "../company/pages/company-staff/list";
import AddCompanyStaff from "../company/pages/company-staff/add";
import EditCompanyOfficeStaff from "../company/pages/company-staff/edit";
import WorkOrderReport from "../company/pages/pms/machinery-register/WorkOrderReport";
import JobRegisterTab from "../company/pages/pms/machinery-register/JobRegisterTab";
import WorkOrderHistoryTab from "../company/pages/pms/machinery-register/WorkOrderHistoryTab";
import WorkOrderTab from "../company/pages/pms/machinery-register/WorkOrderTab";
import TimeDateSettings from "../components/time/TimeDateSettings";

function CompanyRoute() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CompanyDashboardLayout />}>
            <Route path="/" element={<CompanyDashboard />} />
            <Route path="/add-ship/" element={<AddShip />} />
            <Route path="/edit-ship/:id" element={<EditShip />} />
            <Route path="/ships-list" element={<ListShip />} />
            <Route
              path="/list-engine-basic-info"
              element={<ListenginelogBooks />}
            />
            <Route
              path="/view-engine-basic-info/:eng_log_basic_id"
              element={<ViewEngineLogBook />}
            />
            <Route
              path="/company-list-deck-log"
              element={<CompanyDeckLogBookList />}
            />
            <Route
              path="/company-edit-deck-log/:id"
              element={<CompanyViewDeckLog />}
            />
            <Route path="/company-staff-add" element={<AddStaff />} />
            <Route
              path="/company-staff-update/:staff_id/:shipid/"
              element={<EditStaff />}
            />
            <Route path="/company-staff-list" element={<ListStaff />} />
             <Route path="/company-staff" element={<CompanyOfficeStaffList />} />
             <Route path="/company-office-staff-add" element={<AddCompanyStaff />} />
             <Route path="/edit-company-staff/:staff_id" element={<EditCompanyOfficeStaff/>} />
            <Route path="/voyage-list" element={<VoyageListing />} />
            <Route path="/voyage-view/:id" element={<EditVoyage />} />
            <Route
              path="/company-list-sound-log"
              element={<CompanySoundLogBookList />}
            />
            <Route
              path="/company-view-sound-log/:soundingLog_id"
              element={<CompanySoundLogBookViewList />}
            />
            <Route path="/list-garbage-log" element={<GarbageLogBookList />} />
            <Route
              path="/view-garbage-log-com/:garbage_id"
              element={<ViewGarbageLog />}
            />
            <Route
              path="/view-audit-trail-garbage-log-com"
              element={<AuditTrailGarbage />}
            />
            <Route
              path="/list-garbage-log-two"
              element={<GarbageLogBookListTwo />}
            />
            <Route
              path="/view-garbage-log-com-two/:garbage_id"
              element={<ViewGarbageLogTwo />}
            />
            <Route
              path="/view-audit-trail-garbage-log-two"
              element={<AuditTrailGarbageTwo />}
            />
            <Route path="/list-oil-record-log" element={<ListOilRecordLog />} />
            <Route
              path="/list-oil-record-log-two"
              element={<ListOilRecordLogTwo />}
            />
            <Route
              path="/view-oil-record-log-com/:oil_record_id"
              element={<ViewOilRecordLog />}
            />
            <Route
              path="/view-oil-record-log-com-two/:oil_record_id"
              element={<ViewOilRecordLogTwo />}
            />
            <Route
              path="/daily-ship-staff-task"
              element={<DailyShipStaffTask />}
            />
            <Route
              path="/view-daily-ship-staff-task/:id"
              element={<ViewDailyShipStaffTask />}
            />
            <Route
              path="/view-audit-trail-staff"
              element={<AuditTrailstaffcom />}
            />
            <Route
              path="/view-audit-trail-voyage"
              element={<AuditTrailvoyagecom />}
            />
            <Route
              path="/view-audit-trail-deck-log"
              element={<AuditTrailDeckCom />}
            />
            <Route
              path="/view-audit-trail-engine-log"
              element={<AuditTrailEnginelog />}
            />
            <Route
              path="/view-audit-trail-sounding-log"
              element={<AuditTrailSounding />}
            />
            <Route
              path="/view-audit-trail-oil-com"
              element={<AuditTrailOil />}
            />
            <Route
              path="/view-audit-trail-oil-com-two"
              element={<AuditTrailOilTwo />}
            />
            <Route
              path="/view-audit-trail-daily-com"
              element={<AuditTraildaily />}
            />
            <Route
              path="/cii-calculation-list-com"
              element={<CIICalculationList />}
            />
            <Route path="/company-profile" element={<CompanyProfile />} />
            <Route
              path="/utilities/settings/time-date"
              element={<TimeDateSettings />}
            />
            <Route
              path="/daily-consumption"
              element={<DailyConsumptionList />}
            />
            <Route
              path="/view-ballast-record-com/:ballast_id"
              element={<ViewBallastRecordBook />}
            />
            <Route
              path="/list-ballast-record-com"
              element={<ListBallastRecordbook />}
            />
            <Route
              path="/audit-trail-ballast-record-com"
              element={<AuditTrailBallastRecord />}
            />
            <Route
              path="/list-bunker-record-com"
              element={<ListBunkerReportCom />}
            />
            <Route
              path="/view-bunker-record-com/:record_id"
              element={<ViewBunkerReportCom />}
            />
            <Route
              path="/list-bunker-detail-com"
              element={<ListBunkerDetailsCom />}
            />
            <Route
              path="/view-bunker-details-com/:bunker_id"
              element={<EditBunkerDetailsCom />}
            />
            <Route
              path="/list-bunker-delivery-note-com"
              element={<ListBunkerDeliveryCom />}
            />
            <Route
              path="/view-bunker-delivery-note-com/:bunkerdelivery_id"
              element={<ViewBunkerDeliveryCom />}
            />
            <Route
              path="/list-fuel-changeover-com"
              element={<ListFuelChangeoverCom />}
            />
            <Route
              path="/view-fuel-changeover-com/:fuel_id"
              element={<ViewBunkerFuelChangeoverCom />}
            />
            <Route
              path="/audit-trail-daily-comsumption"
              element={<AuditTraildailyComsumption />}
            />
            <Route
              path="/audit-trail-bunker-record"
              element={<AuditTrailBunkerRecord />}
            />
            <Route
              path="/audit-trail-bunker-delivery-note-com"
              element={<AuditTrailBunkerdelivery />}
            />
            <Route
              path="/audit-trail-fuel-changeover"
              element={<AuditTrailFuelChangeover />}
            />
            <Route
              path="/audit-trail-bunker-details"
              element={<AuditTrailBunker />}
            />
            <Route
              path="/view-cargo-record-com/:cargo_id"
              element={<ViewCargoRecordBook />}
            />
            <Route
              path="/list-cargo-record-com"
              element={<ListCargoRecordbook />}
            />
            <Route
              path="/audit-trail-cargo-record-com"
              element={<AuditTrailCargo />}
            />
            <Route path="/ship-Comparison" element={<ShipComparisonPage />} />
            <Route path="/all-issues" element={<AllIssues />} />
            <Route path="/bug-report-list" element={<Bugs />} />
            <Route path="/change-request-list" element={<ChangeRequests />} />
            <Route path="/feature-request-list" element={<FeatureRequest />} />
            <Route path="/feedback-list" element={<Feedback />} />
            <Route path="/equip-containing-log" element={<ListCompanyEquipContainingLog />} />
            <Route path="/view-equip-containing-log/:id" element={<ViewCompanyEquipContainingLog />} />
            <Route path="/supply-and-discharge-log" element={<ListCompanySupplyAndDischargeLog />} />
            <Route path="/view-supply-and-discharge-log/:id" element={<ViewCompanySupplyAndDischargeLog />} />
            <Route path="/refrigeration-equip-log" element={<ListCompanyRefrigerationEquipLog />} />
            <Route path="/view-refrigeration-equip-log/:id" element={<ViewCompanyRefrigerationEquipLog />} />
            <Route path="/photographic-analysis" element={<PhotographicAnalysisList />} />
            <Route path="/photographic-analysis-form" element={<PhotographicAnalysis />} />
            <Route path="/machinery-register" element={<MachineryRegisterList />} />
            <Route path="/add-machinery" element={<AddMachinery />} />
            <Route path="/equipment-register" element={<EquipmentRegisterList />} />
            <Route path="/add-equipment" element={<AddEquipment />} />
            <Route path="/function-hirerachy" element={<FunctionHierarchy />} />
            <Route path="/maintenance-log" element={<JobTasksList />} />
            <Route path="/maintenance-log/:id" element={<JobTaskView />} />
            <Route path="/work-order/:id" element={<WorkOrderReport />} />
            <Route path="/job-register" element={<JobRegisterTab />} />
            <Route path="/work-order-tab" element={<WorkOrderTab />} />
            <Route path="/work-order-history" element={<WorkOrderHistoryTab />} />
            {/* Rest Hours — company view */}
            <Route path="/resthours/fleet-overview" element={<RestHoursDashboardCom />} />
            <Route path="/com-rest-hours-log-list" element={<RestHoursLogListCom />} />
            <Route path="/resthours/crew-records" element={<RestHoursCrewRecordsCom />} />
            <Route path="/work-rest/crew-records" element={<RestHoursCrewRecordsCom />} />
            <Route path="/log-hours" element={<LogHours />} />
            <Route path="/resthours/records" element={<RestHoursRecordsCom />} />
            <Route path="/resthours/violations" element={<ViolationsCom />} />
            <Route path="/violations" element={<ViolationsCom />} />

            {/*
              API module routes. SidebarNavigation uses the paths returned by
              company-modules directly; legacy routes above remain available
              for links inside the existing screens.
            */}
            <Route path="/dashboard" element={<CompanyDashboard />} />
            <Route path="/fleet/vessels" element={<ListShip />} />
            <Route
              path="/fleet/ship-comparison"
              element={<ShipComparisonPage />}
            />
            <Route path="/fleet/staff" element={<ListStaff />} />
            <Route
              path="/fleet/company-staff"
              element={<CompanyOfficeStaffList />}
            />
            <Route
              path="/vessel-operations/voyages"
              element={<VoyageListing />}
            />

            <Route
              path="/maintenance"
              element={<Navigate to="/maintenance/dashboard" replace />}
            />
            <Route path="/maintenance/dashboard" element={<CompanyDashboard />} />
            <Route
              path="/maintenance/machinery-register"
              element={<MachineryRegisterList />}
            />
            <Route
              path="/maintenance/function-hierarchy"
              element={<FunctionHierarchy />}
            />
            <Route
              path="/maintenance/equipment-register"
              element={<EquipmentRegisterList />}
            />
            <Route
              path="/maintenance/job-register"
              element={<JobRegisterTab />}
            />
            <Route path="/maintenance/log" element={<JobTasksList />} />

            <Route
              path="/rest-hours"
              element={<Navigate to="/rest-hours/fleet-overview" replace />}
            />
            <Route
              path="/rest-hours/fleet-overview"
              element={<RestHoursDashboardCom />}
            />
            <Route
              path="/rest-hours/crew-records"
              element={<RestHoursCrewRecordsCom />}
            />
            <Route
              path="/rest-hours/reports"
              element={<RestHoursRecordsCom />}
            />
            <Route
              path="/rest-hours/violations"
              element={<ViolationsCom />}
            />

            <Route
              path="/ship-records/logbooks/engine"
              element={<ListenginelogBooks />}
            />
            <Route
              path="/ship-records/logbooks/deck"
              element={<CompanyDeckLogBookList />}
            />
            <Route
              path="/ship-records/logbooks/sounding"
              element={<CompanySoundLogBookList />}
            />
            <Route
              path="/ship-records/record-books/cargo"
              element={<ListCargoRecordbook />}
            />
            <Route
              path="/ship-records/oil-record-book/part-1"
              element={<ListOilRecordLog />}
            />
            <Route
              path="/ship-records/oil-record-book/part-2"
              element={<ListOilRecordLogTwo />}
            />
            <Route
              path="/ship-records/garbage-record-book"
              element={
                <Navigate
                  to="/ship-records/garbage-record-book/part-1"
                  replace
                />
              }
            />
            <Route
              path="/ship-records/garbage-record-book/part-1"
              element={<GarbageLogBookList />}
            />
            <Route
              path="/ship-records/garbage-record-book/part-2"
              element={<GarbageLogBookListTwo />}
            />
            <Route
              path="/ship-records/record-books/ballast-water"
              element={<ListBallastRecordbook />}
            />
            <Route
              path="/ship-records/record-books/bunker"
              element={<ListBunkerReportCom />}
            />
            <Route
              path="/ship-records/record-books/ods"
              element={
                <Navigate
                  to="/ship-records/record-books/ods/equipment-containing"
                  replace
                />
              }
            />
            <Route
              path="/ship-records/record-books/ods/equipment-containing"
              element={<ListCompanyEquipContainingLog />}
            />
            <Route
              path="/ship-records/record-books/ods/supply-discharge"
              element={<ListCompanySupplyAndDischargeLog />}
            />
            <Route
              path="/ship-records/record-books/ods/refrigeration"
              element={<ListCompanyRefrigerationEquipLog />}
            />

            <Route
              path="/environment/consumption"
              element={<Navigate to="/environment/consumption/daily" replace />}
            />
            <Route
              path="/environment/consumption/daily"
              element={<DailyConsumptionList />}
            />
            <Route
              path="/environment/compliance/cii-calculation"
              element={<CIICalculationList />}
            />
            <Route
              path="/environment/compliance/sulphur-record-book"
              element={
                <Navigate
                  to="/environment/compliance/sulphur-record-book/bd"
                  replace
                />
              }
            />
            <Route
              path="/environment/compliance/sulphur-record-book/bd"
              element={<ListBunkerDetailsCom />}
            />
            <Route
              path="/environment/compliance/sulphur-record-book/bdn"
              element={<ListBunkerDeliveryCom />}
            />
            <Route
              path="/environment/compliance/sulphur-record-book/fcr"
              element={<ListFuelChangeoverCom />}
            />

            <Route
              path="/issues"
              element={<Navigate to="/issues/all" replace />}
            />
            <Route path="/issues/all" element={<AllIssues />} />
            <Route path="/issues/bugs" element={<Bugs />} />
            <Route
              path="/issues/change-requests"
              element={<ChangeRequests />}
            />
            <Route
              path="/issues/feature-requests"
              element={<FeatureRequest />}
            />
            <Route path="/issues/feedback" element={<Feedback />} />

            <Route
              path="/utilities/settings/company-profile"
              element={<CompanyProfile />}
            />
            <Route
              path="/utilities/other-logs/daily-staff-task"
              element={<DailyShipStaffTask />}
            />
            <Route
              path="/utilities/other-logs/notifications"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/utilities/photographic-analysis"
              element={<PhotographicAnalysisList />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default CompanyRoute;
